import React, { useEffect, useState } from 'react';
import Styles from './styles.module.sass';
import { NavLink } from "react-router-dom";
import { SUB_DIRECTORY } from "constants/general";

const AsideGuestLayout = (props) => {

    const {
        flow = 1
    } = props

    const dataSection = [
        {
            titleSection: 'Mi Crédito Sears',
            sections: [
                {
                    title: 'Mis Tarjetas',
                    url: `/${SUB_DIRECTORY}consultar-saldo`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Movimientos',
                    url: `/${SUB_DIRECTORY}movimientos-tarjeta`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Estado de cuenta',
                    url: `/${SUB_DIRECTORY}solicitar-estado-cuenta`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Pago express',
                    url: `/${SUB_DIRECTORY}pago-express`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Agregar tarjeta',
                    url: `/${SUB_DIRECTORY}agregar-tarjeta`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                }
            ]
        },
        {
            titleSection: 'Conoce Crédito Sears',
            sections: [
                {
                    title: 'Beneficios y Promociones',
                    url: `/${SUB_DIRECTORY}beneficios`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Solicita tu tarjeta',
                    url: `/${SUB_DIRECTORY}solicitud-credito-sears`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Autotal Inbursa',
                    url: `https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&amp;pa=P&amp;pro=SEARS#no-back-button`,
                    target: '_blank',
                    iconClass: 'opc',
                    status: true
                },
            ]
        },
    ]

    const dataGuestSection = [
        {
            titleSection: 'Crédito Sears',
            sections: [
                {
                    title: 'Registrar tarjeta',
                    url: `/${SUB_DIRECTORY}agregar-tarjeta`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Solicita tu tarjeta',
                    url: `/${SUB_DIRECTORY}solicitud-credito-sears`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Pago express',
                    url: `/${SUB_DIRECTORY}pago-express`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                }
            ]
        },
        {
            titleSection: 'Conoce Crédito Sears',
            sections: [
                {
                    title: 'Beneficios y Promociones',
                    url: `/${SUB_DIRECTORY}beneficios`,
                    target: null,
                    iconClass: 'opc',
                    status: true
                },
                {
                    title: 'Autotal Inbursa',
                    url: `https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&amp;pa=P&amp;pro=SEARS#no-back-button`,
                    target: '_blank',
                    iconClass: 'opc',
                    status: true
                },
            ]
        },
    ]
    
    const [ menu, setMenu ] = useState(dataGuestSection)

    useEffect(()=>{
        if(flow){
            if(flow > 2 ){
                setMenu(dataSection)
            }else if(flow < 3 ){
                setMenu(dataGuestSection)
            }
        }
    },[flow])

    const toggle = () => {
        document.querySelector('main').classList.toggle('showMenu')
    }

    return(
        <aside className={Styles?.moduleCardMenuContainer}>
            <div className={Styles?.moduleCardMenu}>
                {
                    menu?.length > 0
                        ? menu?.map((item, index) => (
                            <ul className={Styles?.ulMiCredito} key={index}>
                                <li className={Styles?.titleCredito}>{item?.titleSection}</li>
                                {item?.sections?.length > 0
                                    ? item?.sections?.map((section, ind) => {
                                        return(
                                            <li className={Styles?.opc} key={ind}>
                                                {!section?.target
                                                    ?
                                                        <NavLink 
                                                            to={section?.url}
                                                            className={`${Styles?.cardMenuItem} ${Styles?.[section?.iconClass]}`}
                                                            activeClassName={`${Styles?.cardMenuItem} ${Styles?.[section?.iconClass]} ${Styles?.active}`}
                                                        >{section.title}</NavLink>
                                                    : 
                                                        <a 
                                                            href={section?.url} 
                                                            target={section?.target}
                                                            className={`${Styles?.cardMenuItem} ${Styles?.[section?.iconClass]}`}
                                                        >{section?.title}</a>
                                                }
                                            </li>
                                        )
                                    })
                                    : null
                                }
                            </ul>
                        ))
                        : null
                }
            </div>
            <div className={Styles?.darkMenu} onClick={toggle}></div>
        </aside>
    )
}

export default AsideGuestLayout;